var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',[_c('img',{attrs:{"src":"/assets/icon/icon-delete.svg"}}),_vm._v("\n  "+_vm._s(_vm.$t('Warenkorb leeren'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }